import { getErrorMessage, toast, useI18n } from "@humanex/ui/libs";
import { useMutation } from "@tanstack/react-query";

import { publicApiClient } from "@/libs/api";

export function useUploadImage() {
  const { t } = useI18n();
  return useMutation({
    mutationFn: (file: File) => publicApiClient.uploadImage(file),
    onError: (error: unknown) => {
      toast.error(getErrorMessage(error) || t("common.error.tryAgain"));
    }
  });
}
